"use client";
import { m } from "framer-motion";
import { forwardRef } from "react";
import Image from "next/image";

const CubeComponent = forwardRef((props, ref) => {
  return (
    <div
      ref={ref}
      className="relative w-[248px] h-[248px] sm:w-[278px] sm:h-[278px] md:w-[332px] md:h-[332px] tablet:w-[400px] tablet:h-[400px] lg:w-[450px] lg:h-[450px] xl:w-[536px] xl:h-[536px] laptop:w-[600px] laptop:h-[600px] 3xl:w-[640px] 3xl:h-[640px] overflow-visible"
    >
      {/* Main cube flying in from the left */}
      <m.div
        initial={{ opacity: 1, x: -200, scale: 3 }}
        animate={{ x: 0, scale: 1, opacity: 1 }}
        transition={{ duration: 0.84, ease: "easeOut" }}
        className="w-full h-full flex justify-self-end absolute z-30 right-0  will-change-transform will-change-opacity"
      >
        <Image
          src="/assets/home/cube-main.webp"
          alt="Main Cube"
          width={640}
          height={640}
          priority
          sizes="(max-width: 640px) 248px, 
         (max-width: 768px) 278px,  
         (max-width: 900px) 332px,  
         (max-width: 1024px) 400px,
         (max-width: 1280px) 450px, 
         (max-width: 1440px) 536px,  
         (max-width: 1800px) 600px, 
         640px"
          className="object-contain -rotate-3"
        />
      </m.div>

      {/* black one coming from top right */}
      <m.div
        initial={{ x: 100, y: -200, opacity: 1 }}
        animate={{ x: 0, y: 0 }}
        transition={{ duration: 0.8, ease: "easeIn", delay: 0.04 }}
        className="absolute -top-5 sm:-top-6 md:-top-7 tablet:-top-9 lg:-top-10 xl:-top-12 laptop:-top-13 
        left-11 sm:left-12 md:left-15 tablet:left-17 lg:left-19 xl:left-23 laptop:left-26 3xl:left-28   
        w-[135px] sm:w-[160px] md:w-[180px] tablet:w-[220px] lg:w-[250px] xl:w-[300px] laptop:w-[335px] 3xl:w-[347px]
        z-50 will-change-transform will-change-opacity"
      >
        <Image
          src="/assets/home/cube-part-02.webp"
          alt="Cube Part 02"
          width={347}
          height={240}
          sizes="(max-width: 640px) 135px, 
         (max-width: 768px) 160px,  
         (max-width: 900px) 180px,
         (max-width: 1024px) 220px,
         (max-width: 1280px) 250px, 
         (max-width: 1440px) 300px,  
         (max-width: 1800px) 335px, 
         347px"
          className="object-contain -rotate-2"
        />
      </m.div>

      {/* black one coming from left bottom */}
      <m.div
        initial={{ x: -350, y: 300, opacity: 1 }}
        animate={{ x: 0, y: 0 }}
        transition={{ duration: 0.8, ease: "easeIn", delay: 0.04 }}
        className="absolute top-25 sm:top-28 md:top-34 tablet:top-40 lg:top-44 xl:top-55 laptop:top-62 3xl:top-67   
        -left-5 sm:-left-6 md:-left-7 tablet:-left-8 lg:-left-10 xl:-left-12 3xl:-left-13  
        w-[104px] sm:w-[118px] md:w-[138px] tablet:w-[170px] lg:w-[196px] xl:w-[220px] laptop:w-[240px] 3xl:w-[250px] 
        object-contain rotate-3 z-0 will-change-transform will-change-opacity"
      >
        <Image
          src="/assets/home/cube-part-03.webp"
          alt="Cube Part 03"
          width={250}
          height={180}
          sizes="(max-width: 640px) 104px, 
         (max-width: 768px) 118px,  
         (max-width: 900px) 138px,
         (max-width: 1024px) 170px,
         (max-width: 1280px) 196px, 
         (max-width: 1440px) 220px,  
         (max-width: 1800px) 240px, 
         250px"
          className="object-contain"
        />
      </m.div>

      {/* pink crystal coming from right bottom */}
      <m.div
        initial={{ x: 100, y: 300, opacity: 1 }}
        animate={{ x: 0, y: 0 }}
        transition={{ duration: 0.8, ease: "easeIn", delay: 0.04 }}
        className="absolute top-47 sm:top-52 md:top-63 tablet:top-76 lg:top-84 xl:top-100 laptop:top-111 3xl:top-119   
        left-15 sm:left-18 md:left-22 tablet:left-27 lg:left-29 xl:left-35 laptop:left-38 3xl:left-41  
        w-[84px] sm:w-[90px] md:w-[100px] tablet:w-[122px] lg:w-[145px] xl:w-[175px] laptop:w-[200px] 3xl:w-[210px] 
        -rotate-7 z-0 will-change-transform will-change-opacity"
      >
        <Image
          src="/assets/home/cube-part-01.webp"
          alt="Cube Part 01"
          width={210}
          height={200}
          sizes="(max-width: 640px) 84px, 
         (max-width: 768px) 90px,  
         (max-width: 900px) 100px,
         (max-width: 1024px) 122px,
         (max-width: 1280px) 145px, 
         (max-width: 1440px) 175px,  
         (max-width: 1800px) 200px, 
         210px"
          className="object-contain"
        />
      </m.div>
    </div>
  );
});

export default CubeComponent;
